import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { Badge } from '@mui/material'
import { DateCalendar, DayCalendarSkeleton, PickersDay } from '@mui/x-date-pickers'
import { endOfMonth, startOfMonth } from 'date-fns'
import { chain } from 'lodash'
import { useFirestore } from '../../hooks/useFirestore'
import { BOOKING_COLLECTION, BOOKING_TYPE_ACTIVITY, BOOKING_TYPE_FLIGHT } from '../../_constants/globals'


const DaySelector = ({ value, onChange }) => {
  
  const bookingHooks = useFirestore(BOOKING_COLLECTION, { storeAs: 'DaySelector' })
  const dbBookings = bookingHooks.getDocs()
  
  const [month, setMonth] = useState(startOfMonth(value))
  
  const bookingsPerDay = useMemo(
    () => chain(dbBookings)
      .filter(b => b.bookingType === BOOKING_TYPE_FLIGHT || b.bookingType === BOOKING_TYPE_ACTIVITY)
      .map(b => b.days?.map(str => Number(str.slice(0, 2))))
      .flatten()
      .countBy()
      .value(),
    [dbBookings],
  )
  
  useEffect(() => {
    bookingHooks.listen({
      where: [
        ['startDate', '<=', endOfMonth(month)],
        ['endDate', '>=', month],
      ],
      orderBy: [['startDate', 'asc']],
    })
    return bookingHooks.unsubscribe
  }, [month])
  
  return (
    <DateCalendar
      value={value}
      onChange={onChange}
      loading={!bookingsPerDay}
      onMonthChange={setMonth}
      renderLoading={() => <DayCalendarSkeleton />}
      displayWeekNumber
      slots={{
        day: ({ day, outsideCurrentMonth, ...other }) => <Badge
          color='secondary'
          overlap='circular'
          badgeContent={outsideCurrentMonth ? null : bookingsPerDay[day.getDate()]}
        >
          <PickersDay {...other} outsideCurrentMonth={outsideCurrentMonth} day={day} />
        </Badge>,
      }}
    />
  )
}

DaySelector.propTypes = {
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default DaySelector
